import { configureStore } from "@reduxjs/toolkit";
import { cohortSliceReducer } from "~/features/Cohort";
import { dashboardSliceReducer } from "~/features/Dashboard";
import { mobileDrawerContentSliceReducer } from "~/features/MobileDrawerContent";
import { modalWithStateSliceReducer } from "~/features/ModalWithState";
import { programSliceReducer } from "~/features/Program";
import { api } from "./api";
import { reducer as authenticationReducer } from "./authentication";
import { reducer as gitShaReducer } from "./gitSha";
import { reducer as onboardingReducer } from "./onboarding";

// ! Note: Reducers should be imported from a `**/features/**/*` directory.
// ! It's kind of the point of having Redux -- to manage complex state and/or
// ! state that is needed across the app.
// ! For more info about what should and should not go into Redux, see:
// ! https://redux.js.org/tutorials/essentials/part-2-app-structure#component-state-and-forms
export const store = configureStore({
  reducer: {
    authentication: authenticationReducer,
    cohort: cohortSliceReducer,
    dashboard: dashboardSliceReducer,
    gitSha: gitShaReducer,
    mobileDrawerContent: mobileDrawerContentSliceReducer,
    modalWithState: modalWithStateSliceReducer,
    onboarding: onboardingReducer,
    program: programSliceReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
